import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-netflix-support',
  templateUrl: './netflix-support.component.html',
  styleUrls: ['./netflix-support.component.sass']
})
export class NetflixSupportComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  constructor(public global:GlobalService) { }

  ngOnInit() {
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
